import { render, staticRenderFns } from "./ConfigurableDocumentList.vue?vue&type=template&id=18de75f8&"
import script from "./ConfigurableDocumentList.vue?vue&type=script&lang=js&"
export * from "./ConfigurableDocumentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports